export default __webpack_public_path__ + "static/media/gmail-icon-footer.34eb7bc4.svg";